export default {
    ordersLayout: {
        back: "Kembali",
        emptyOrders: "Anda belum mempunyai sebarang pesanan.",
        loading: "Memuatkan",
        storeLabel: "Kedai",
        totalLabel: "Jumlah",
        storeAddressPending: "Alamat akan tersedia tidak lama lagi",
        productNameFallback: "Produk",
        ecListTitle: "Pesanan anda",
        ecStatusInStore: "Status: pembelian di kedai",
        ecOrderNumber: "Nombor pesanan: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} item: jumlah {{amount}}",
        ecCountTotalOther: "{{count}} item: jumlah {{amount}}",
        ecViewOrder: "Lihat pesanan >",
        ecViewOrderA11y: "Lihat pesanan {{order_number}}",
        ecBackToOrders: "Kembali ke pesanan anda",
        ecInStoreDate: "Pembelian di kedai – {{date}}",
        ecProductsOne: "Produk",
        ecProductsOther: "Produk",
        ecSku: "Ruj. {{sku}}",
        ecQty: "Kuantiti: {{qty}}",
        ecWarrantyExpired: "Tamat waranti",
        ecWarrantyActive: "Dalam tempoh waranti",
        ecSubtotalOne: "Subjumlah – {{count}} item",
        ecSubtotalOther: "Subjumlah – {{count}} item",
    }
}



// WEBPACK FOOTER //
// ./src/locales/ms/index.js